import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { ERROR } from '../../../constants';
import { Context } from '../Context';
const FieldError = forwardRef(({ as: Element = 'p', children, render, ...rest }, ref) => {
    const { id, isInvalid, isLoading, isRequired } = useContext(Context);
    return (_jsx(Element, { ref: ref, id: `${id}-error`, role: "alert", ...rest, children: render ? render({ isInvalid, isLoading, isRequired }) : children }));
});
FieldError.displayName = ERROR;
export { FieldError };
//# sourceMappingURL=Error.js.map